<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <button class="header-reserve" @click="openRegister" aria-label="방문 예약하기">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
          </svg>
          <span class="reserve-label">방문 예약</span>
        </button>
        <router-link to="/" class="logo" aria-label="Le-el River Park Centum">
          <span class="logo-img"></span>
        </router-link>
        <a href="tel:010-4431-4422" class="header-tel">
          <svg class="tel-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
          </svg>
          <span class="tel-num">010.4431.4422</span>
        </a>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader',
  methods: {
    openRegister() {
      window.dispatchEvent(new Event('open-register-popup'))
    }
  }
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: var(--le-noir, #0B0B0F);
  border-bottom: 1px solid rgba(201, 169, 107, 0.2);
  transition: background 0.3s ease;
}

.header-inner {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
}

.logo {
  display: flex;
  align-items: center;
  text-decoration: none;
}

.logo-img {
  display: block;
  width: 160px;
  height: 32px;
  background: linear-gradient(180deg, #F4EFE6 0%, #DEC18A 55%, #C9A96B 100%);
  -webkit-mask: url('@/assets/logo/logo.png') no-repeat center / contain;
          mask: url('@/assets/logo/logo.png') no-repeat center / contain;
}

.header-reserve {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid rgba(201, 169, 107, 0.45);
  border-radius: 999px;
  padding: 7px 12px;
  color: #DEC18A;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s ease;
}
.header-reserve:active {
  background: rgba(222, 193, 138, 0.12);
}
.reserve-label {
  font-family: 'Paperlogy', system-ui, sans-serif;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1;
}

.header-tel {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  color: #DEC18A;
  padding: 7px 12px;
  border: 1px solid rgba(201, 169, 107, 0.45);
  border-radius: 999px;
}

.tel-icon {
  flex-shrink: 0;
}

.tel-num {
  font-family: 'Paperlogy', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.04em;
  line-height: 1;
}
</style>
